import {Component, inject, OnInit, ViewChild} from '@angular/core';
import { PortalUsuarioService } from '../../../services/database/portal-usuario.service';
import { ButtonColumnType, CustomTableComponent,  DataColumnType, ICustomTable, IHeader } from 'lib-base';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { IGetPortalUsuarios } from '../../../shared/interfaces/database/seguridad';
import { PortalUsuarioEmpresaComponent } from './portal-usuario-empresa.component';
import {CustomTitleDirective} from "../../../shared/clases/custom-title.directive";

@Component({
  selector: 'app-portal-usuario',
  standalone: true,
  imports: [TranslateModule, CustomTableComponent, PortalUsuarioEmpresaComponent],
  template: `

  <section class="flex justify-content-center mt-4">
	  <div class="card-table col-12 pt-6">
        <custom-table [config]="customTable" [rowExpansionTemplate]="tableRowexpansion">
        </custom-table>

        <ng-template #tableRowexpansion let-data>
          <app-portal-usuario-empresa [portalUsuarioId]="data.id" class="app-card w-11 mx-auto border-1 border-top-none border-noround-top"></app-portal-usuario-empresa>
        </ng-template>
      </div>
  </section>
  `,
})
export class PortalUsuarioComponent implements OnInit {

  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;

  constructor(private readonly _pu: PortalUsuarioService, private readonly _t: TranslateService) { }
  private titleService:CustomTitleDirective = inject(CustomTitleDirective);

  ngOnInit(): void {
    this.titleService.changeTitle('common.usuarioFirmaElectronica');
    this.translate().then(() => this.configTable());
    this.getPortalUsuarios();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      tipoIdentificacion: this._t.get('common.tipoIdentificacion'),
      identificacion: this._t.get('common.identificacion'),
      nombre: this._t.get('common.nombre'),
      correo: this._t.get('common.correo'),
      fechaCreacion: this._t.get('common.fechaCreacion'),
      fechaInactivacion: this._t.get('common.fechaInactivacion'),
      title: this._t.get('common.usuarioFirmaElectronica'),
    }));
  }

  private configTable() {
    this.customTable = {
      header: {
        title: this.trans.title,
        class:"title font-roboto-condensed font-18 title-blue text-uppercase font-normal mb-0",
      } as IHeader,
      columns: [
        {
          field: 'expand',
          header: '',
          class: 'p-button-info',
          width: '0.5rem',
          buttonType: ButtonColumnType.EXPANDED
        },
        {
          field: 'tipoIdentificacion',
          header: this.trans.tipoIdentificacion,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'identificacion',
          header: this.trans.identificacion,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'nombreCompleto',
          header: this.trans.nombre,
          columnFilter: true,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'correo',
          header: this.trans.correo,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaCreacion',
          header: this.trans.fechaCreacion,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          width: '13rem',
          sort: true,
          dataType: DataColumnType.DATE
        },
        {
          field: 'fechaInactivacion',
          header: this.trans.fechaInactivacion,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          width: '13rem',
          sort: true,
          dataType: DataColumnType.DATE
        }
      ],
    } as ICustomTable;
  }

  //#region API Calls

  private getPortalUsuarios() {
    this._pu.getPortalUsuarios().subscribe((data: IGetPortalUsuarios[]) => {
      this.customTableComponent.data = data;
    });
  }
  //#endregion
}
